import React from 'react';
import { Link, Route, Switch } from 'react-router-dom';
import Carousel from './Carousel';
import Glucanosom from './Glucanosom';
import DermaGlucan from './DermaGlucan';
import LeviAll from './LeviAll';
import FlaxPower from './FlaxPower';
import Nav from './Nav';
import Footer from './Footer';
import logo from '../images/biglogo.png';
import { Container, Divider, Header, Image, Segment } from 'semantic-ui-react';

class App extends React.Component {
  state = { activeItem: window.location.hash.replace('#/', '') }

  componentDidMount() {
    this.updateTitle((items.find((a) => a.value === this.state.activeItem) || {}).text)
  }

  componentDidUpdate() {
    const title = window.location.hash.replace('#/', '');
    if (this.state.activeItem !== title) {
      this.setState({ activeItem: title }, this.updateTitle((items.find((a) => a.value === title) || {}).text))
    }
  }

  handleItemClick = (e, { name, value }) => this.setState({ activeItem: name }, this.updateTitle(value));

  mobile = () => window.innerWidth < 768;


  updateTitle = (title) => {
    if (title) {
      let headTitle = document.querySelector('head title');
      headTitle.innerHTML = title.length && title !== 'Home' ? `BioSwiss - ${title}` : 'BioSwiss';
    }
  }

  render() {
    return (
      <div>
        <Nav items={items} activeItem={this.state.activeItem} handleItemClick={this.handleItemClick} />
        <Container as={Segment} secondary padded className='nav-space'>
          <Link to=''>
            <Image size='large' centered src={logo} />
          </Link>

          <Divider horizontal className='unless-mobile' style={{ padding: '14px 0px' }}>
            US Distribution Office ABAC Products
          </Divider>

          <Header textAlign='center' className='if-mobile'>
            US Distribution Office ABAC Products
          </Header>

          <Switch>
            <Route exact path='/glucanosom' component={Glucanosom} />
            <Route exact path='/dermaglucan' component={DermaGlucan} />
            <Route exact path='/leviall' component={LeviAll} />
            <Route exact path='/flaxpower' component={FlaxPower} />
          </Switch>

          <div style={{ marginTop: 14 }}>
            <Carousel currentIndex={(items.find((a) => a.value === this.state.activeItem) || {}).carouselIndex} />
          </div>
        </Container>
        <br />
        <Footer />
      </div>
    );
  }
}

const items = [
  { text: 'Home', value: '', carouselIndex: 0 },
  { text: 'Glucanosom', value: 'glucanosom', carouselIndex: 0 },
  { text: 'DermaGlucan', value: 'dermaglucan', carouselIndex: 1 },
  { text: 'LeviAll', value: 'leviall', carouselIndex: 1 },
  { text: 'Flax-Power', value: 'flaxpower', carouselIndex: 2 },
]

export default App;


// WEBPACK FOOTER //
// ./src/components/App.js